<template>
    <div class="row">
        <div class="col-20-p" v-for="index in 5">
            <free-style-shimmer
                height="200px"
                width="100%"
                border-radius="10px"
                color="#eeeeee"
            />
            <br>
            <paragraph-shimmer :lines="2" :random-size="true"/>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },

}
</script>

<style scoped>
.col-20-p {
    width: 20%;
    padding: 5px;
}
@media screen and (max-width: 600px) {
    .col-20-p {
        width: 50% !important;
        padding: 5px;
    }
}
</style>
